<template>
<div class="mypage_common cancelMembership">
    <div class="common_head">
        <h5>회원탈퇴</h5>
        <p>서비스 이용계약 해지신청 전 <b>유의사항을 반드시 읽고 숙지</b>하여 주시기 바랍니다.</p>
    </div>
    <div class="common_body">
        <div class="membership_cancel_wrap">
            <ul class="disc">
                <li>서비스 이용계약 해지 완료 시 고객님의 개인정보는 블러썸로고스 구매/판매서비스 이용약관 및 블러썸로고스 개인정보 처리방침 규정에 따라 관리됩니다.</li>
                <li>진행중인 거래 건이 있는 상태에서 서비스 이용계약 해지가 완료되면 더 이상 거래내역을 확인하실 수 없으므로 서비스 이용 계약 해지 신청 전 진행중인 거래 건이 있는지 <br> 다시 한번 확인하여 주시기 바랍니다.</li>
                <li>서비스 이용계약 해지 완료 시 문의내역 및 상품평, 이벤트 페이지 등의 각종 웹 페이지 게시물은 삭제되지 않고 남아 있으며 이에 대한 후 삭제 요청처리 또한 불가피합니다.</li>
                <li>따라서 이러한 게시물에 대한 삭제가 필요하시다면 직접 삭제한 이후에 회원탈퇴 신청을 해주시기 바랍니다.</li>
            </ul>
        </div>
        <div class="tbl_wrap">
            <table class="write type2">
                <tbody>
                    <tr>
                        <th>
                            비밀번호
                        </th>
                        <td>
                            <input type="password" placeholder="비밀번호 입력" v-model="password">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="btn_wrap">
            <button type="button" class="btn_cancel_apply" @click="deleteAccount">탈퇴신청</button>
        </div>
    </div>
</div>
</template>
<script>
import { mapActions, mapState } from 'vuex';

const accountModule = 'accountModule'

export default {
  data () {
    return {
      currentPage: 1,
      password: ''
    }
  },
  methods: {
    ...mapActions(accountModule, ['requestDeleteAccount']),

    async deleteAccount() {
        const {password} = this
        this.$openModal('confirmModal', {
            message: '정말 탈퇴 하시겠습니까?',
            callback: async (confirmed) => {
                if (confirmed) {
                    this.$closeModal
                    const result = await this.requestDeleteAccount({password})
                    this.$openModal('alertModal', {
                        message: result.message
                    })
                    if (result.result === 'true') {
                        this.$router.push({ name: 'home' })
                    }
                } else {
                    this.$closeModal
                }
            }
        })
        
    }
  }
}
</script>